<div
  #kanbanBoard
  class="kanban-board"
  cdkDropListGroup
  *ngIf="columns.length > 0; else emptyKanban"
>
  <section
    class="kanban-column"
    *ngFor="let column of columns; trackBy: trackColumn"
  >
    <header class="kanban-column-header">
      <div class="kanban-column-title">
        <div class="kanban-column-heading">
          <h2
            #columnTitle
            [nz-tooltip]="column.title"
            nzTooltipOverlayClassName="tp-arrowless"
            nzTooltipPlacement="top"
          >
            {{ column.title }}
          </h2>
        </div>
        <div class="kanban-column-metrics">
          <strong>{{ column.cards.length }}</strong>
        </div>
      </div>
    </header>

    <button
      *ngIf="showAddCard"
      type="button"
      class="kanban-add-card"
      (click)="onAddCard(column)"
    >
      <app-st-icon name="add" [bold]="true"></app-st-icon>
      <span>{{ getAddCardLabel() }}</span>
    </button>

    <div
      class="kanban-card-list"
      cdkDropList
      [cdkDropListData]="column"
      (cdkDropListDropped)="dropCard($event)"
    >
      <ng-container *ngIf="column.cards.length > 0; else emptyColumn">
        <div
          class="kanban-card-group"
          *ngFor="let group of column.groups; trackBy: trackGroup"
        >
          <div class="kanban-group-divider" *ngIf="hasGroupTitle(group)">
            <span>{{ group.title }}</span>
            <small>{{ group.cards.length }}</small>
          </div>

          <article
            class="kanban-card"
            cdkDrag
            [cdkDragData]="card"
            [cdkDragDisabled]="groupingActive"
            (cdkDragMoved)="onCardDragMoved($event)"
            (pointerdown)="onCardPointerDown($event)"
            (pointerup)="onCardPointerUp($event, card)"
            *ngFor="let card of group.cards; trackBy: trackCard"
          >
            <div class="kanban-card-head">
              <div>
                <span
                  *ngIf="card.code"
                  class="kanban-card-code"
                  [nz-tooltip]="card.code"
                  nzTooltipOverlayClassName="tp-arrowless"
                  nzTooltipPlacement="top"
                >
                  {{ card.code }}
                </span>
                <h3
                  #cardTitle
                  [nz-tooltip]="card.title"
                  nzTooltipOverlayClassName="tp-arrowless"
                  nzTooltipPlacement="top"
                >
                  {{ card.title }}
                </h3>
                <strong *ngIf="card.amount !== null">
                  {{ formatMoney(card.amount) }}
                </strong>
              </div>
              <nz-avatar
                class="kanban-avatar"
                [nzSize]="20"
                [nzSrc]="card.avatarUrl"
                [nzText]="!card.avatarUrl ? card.avatarText : undefined"
                [nz-tooltip]="card.avatarTooltip || null"
                nzTooltipOverlayClassName="tp-arrowless"
                nzTooltipPlacement="top"
                [style.backgroundColor]="!card.avatarUrl ? '#ffffff' : undefined"
                [style.color]="!card.avatarUrl ? '#000000' : undefined"
                [style.border]="!card.avatarUrl ? '1px solid #d9d9d9' : undefined"
                [style.fontWeight]="!card.avatarUrl ? '600' : undefined"
              ></nz-avatar>
            </div>

            <p
              *ngIf="card.subtitle"
              #cardSubtitle
              [nz-tooltip]="card.subtitle"
              nzTooltipOverlayClassName="tp-arrowless"
              nzTooltipPlacement="top"
            >
              {{ card.subtitle }}
            </p>

            <div class="kanban-card-footer">
              <div class="kanban-tags" *ngIf="card.tags.length > 0">
                <span
                  #tagLabel
                  *ngFor="let tag of card.tags; let tagIndex = index"
                  [class.kanban-tag-secondary]="tagIndex > 0"
                  [nz-tooltip]="tag"
                  nzTooltipOverlayClassName="tp-arrowless"
                  nzTooltipPlacement="top"
                >
                  {{ tag }}
                </span>
              </div>

              <div class="kanban-rating" aria-hidden="true">
                <app-st-icon
                  *ngFor="let star of card.rating"
                  name="star"
                  [filled]="star"
                  [bold]="true"
                ></app-st-icon>
              </div>
            </div>
          </article>
        </div>
      </ng-container>

      <ng-template #emptyColumn>
        <div class="kanban-column-empty">
          <app-st-icon name="inbox" [bold]="false"></app-st-icon>
          <strong>{{ getEmptyTitle() }}</strong>
          <span>{{ getEmptyDescription() }}</span>
        </div>
      </ng-template>
    </div>

  </section>
</div>

<ng-template #emptyKanban>
  <div class="kanban-empty">
    <app-st-icon name="view_kanban" [bold]="true"></app-st-icon>
    <span>No hay registros para mostrar.</span>
  </div>
</ng-template>
